import { axios } from "./AxiosInstance";

export interface IQuestionPaper {
  _id?: string;
  title: string;
  subject: string;
  programId: string;
  duration: number;
  totalMarks: number;
  questionIds: string[];
}


export const createQuestionPaper = async (payload: any) => {
  try {
    const { data } = await axios.post("/question-paper/create", payload); 
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Server error");
  }
};


export const fetchQuestionPapers = async () => {
  const { data } = await axios.get("/question-paper");
  return data; 
};


export const fetchQuestionPaperById = async (id: string) => {
  try {
    const { data } = await axios.get(`/question-paper/${id}`); 
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Question paper not found");
  }
};



export const deleteQuestionPaper = async (id: string) => {
  try {
    const { data } = await axios.delete(`/api/question-paper/${id}`);
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Failed to delete paper");
  }
};


export const deleteMultipleQuestionPapers = async (ids: string[]) => {
  try {
    const { data } = await axios.post(`/api/question-paper/delete-many`, { ids });
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Failed to delete papers");
  }
};

// For student: Get all question papers
export const fetchStudentQuestionPapers = async (studentId: string) => {
  try {
    const { data } = await axios.get("/question-paper/student");
    return data;
  } catch (error: any) {
    throw Error(error.response?.data?.message || "Failed to load papers");
  }
};


export const updateQuestionPaper = async ({ id, updatedData }: any) => {
  if (!id) {
    throw new Error("Missing question paper ID for update");
  }
  const { data } = await axios.put(`/question-paper/${id}`, updatedData);
  return data;
};